<template>
  <!-- 8-1 医疗机构岗位添加页面进度2 -->
  <div class="main-css">
    <div class="main-box">
      <!-- 标题部分 -->
      <div class="top-title">{{ $t("postingJobOffer") }}</div>
      <!-- 进度条部分 -->
      <div class="progress-bar">
        <div class="line-between-active"></div>
        <div class="progress-item-active">
          1 <span class="progress-title">{{ $t("workContent") }}</span>
        </div>
        <div class="line-center-active"></div>
        <div class="progress-item-active">
          2<span class="progress-title">{{ $t("salaryConditions") }}</span>
        </div>
        <div class="line-center-normal"></div>
        <div class="progress-item-normal">
          3<span class="progress-title">{{ $t("confirm") }}</span>
        </div>
        <div class="line-between-normal"></div>
      </div>
      <!-- 第一行 -->
      <div class="one-line-box">
        <div class="small-box">
          <p class="box-title">{{ $t("salary") }}<span>*</span></p>
          <el-dropdown @command="handleCommand3">
            <span class="el-dropdown-link">
              {{ salaryType }}<i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item
                v-for="(item,index) in hourSalaryData"
                :key="item.code"
                :command="item"
              >{{item.name}}</el-dropdown-item>

            </el-dropdown-menu>
          </el-dropdown>
        </div>
        <div class="big-box">
          <el-input v-model="startSalary" @input="inputData(1)" maxlength="21"></el-input>
        </div>
        <span class="tilde">〜</span>
        <div class="big-box">
          <el-input v-model="endSalary" @input="inputData(2)" maxlength="21"></el-input>
        </div>
      </div>
      <!-- 第二行 -->
      <div class="label-line-box">
        <p class="box-title">{{ $t("employmentForm") }}</p>
        <div
          :class="employmentForm1 ? 'label-box-active' : 'label-box'"
          @click="labelIsShow(1)"
        >
          {{ $t("fullTimeEmployee") }}<span @click.stop="labelDel(1)">×</span>
        </div>
        <div
          :class="employmentForm2 ? 'label-box-active' : 'label-box'"
          @click="labelIsShow(2)"
        >
          {{ $t("partTimeJob") }}<span @click.stop="labelDel(2)">×</span>
        </div>
        <div
          :class="employmentForm3 ? 'label-box-active' : 'label-box'"
          @click="labelIsShow(3)"
        >
          {{ $t("specificSkill") }}<span @click.stop="labelDel(3)">×</span>
        </div>
        <div
          :class="employmentForm4 ? 'label-box-active' : 'label-box'"
          @click="labelIsShow(4)"
        >
          {{ $t("technicalInternTrainee")
          }}<span @click.stop="labelDel(4)">×</span>
        </div>
      </div>
      <!-- 第三行 -->
      <div class="big-line-box">
        <div class="big-box-css">
          <p class="box-title">{{ $t("welfare") }}<span>*</span></p>
          <el-input v-model="welfareTreatment" type="textarea" @blur="inputData(3)" maxlength="255"></el-input>
        </div>
      </div>
      <!-- 第四行 -->
      <div class="big-line-box">
        <div class="big-box-css">
          <p class="box-title">
            {{ $t("employmentConditions") }}<span>*</span>
          </p>
          <el-input v-model="employmentConditions" type="textarea" @blur="inputData(4)" maxlength="255"></el-input>
        </div>
      </div>
      <!-- 第五行 -->
      <div class="other-line-box">
        <div class="other-box-css">
          <p class="box-title">{{ $t("other") }}<span>*</span></p>
          <el-input v-model="other" type="textarea" @blur="inputData(5)" maxlength="255"></el-input>
        </div>
      </div>
      <!-- 第六行 -->
      <div class="line-button-box">
        <button class="button-css1" @click="returnClick">{{ $t("return") }}</button>
        <button class="button-css1" @click="saveClick">{{ $t("temporarilySaved") }}</button>
        <button class="button-css2" @click="nextClick">{{ $t("next") }}</button>
      </div>
    </div>
  </div>
</template>
<script>
import {saveJobInfo} from "../../js/api";
import axios from "axios";
import AES from "../../js/AES";

export default {
  name: "medicalInstitutionJobCreation2",
  components: {},
  data() {
    return {
      startSalary: 0,//起薪--------------2
      endSalary: 0,//结束薪资--------2
      employmentForm1: 0,//雇佣形式1--------2
      employmentForm2: 0,//雇佣形式2--------2
      employmentForm3: 0,//雇佣形式3--------2
      employmentForm4: 0,//雇佣形式4--------2
      welfareTreatment: "",//福利待遇-------2
      employmentConditions: "",//录用条件---2
      other: "",//其他---------------------2
      hourSalary: 0,//期望薪资----------?

      jobName: "",//事件名-----------1
      jobPhoto1: "",//事件照片1------1
      jobPhoto2: "",//事件照片2-------1
      jobPhoto3: "",//事件照片3--------1
      label1: 0,//标签1--------1
      label2: 0,//标签2--------1
      label3: 0,//标签3--------1
      label4: 0,//标签4--------1
      principalTime: "",//目标录用时间------1
      recruitNumber: "",//录用人数----------1
      workContent: "",//工作内容-----1
      workSpace: "",//工作地--------1
      workTime: "",//工作时间-------1
      workType: "",//工作种类--------1
      salaryType: "", //給与------?
      labelListHandle: [],
      recruiter:"",
      hourSalaryData:[],
      inputData1:"",
      inputData2:"",
      dataItem1:"",

      pathsList:[],
      urlList:[],
      judgeContinue: false,
      userId:"",
    };
  },
  created() {
    //获取当前语言的值
    this.language = window.localStorage.getItem('language');
    console.log(this.language,"语言")
    this.getLanguage();
    this.jobName=this.$route.params.jobName
    this.jobPhoto1=this.$route.params.jobPhoto1
    this.jobPhoto2=this.$route.params.jobPhoto2
    this.jobPhoto3=this.$route.params.jobPhoto3
    this.workType=this.$route.params.workType
    this.recruitNumber=this.$route.params.recruitNumber
    this.workSpace=this.$route.params.workSpace
    this.workTime=this.$route.params.workTime
    this.recruiter=this.$route.params.recruiter
    this.userId=this.$route.params.userId
    this.principalTime=this.$route.params.principalTime
    this.label1=this.$route.params.label1
    this.label2=this.$route.params.label2
    this.label3=this.$route.params.label3
    this.label4=this.$route.params.label4
    this.workContent=this.$route.params.workContent
    // this.inputData1=this.$route.params.inputData1

  this.salaryType = this.$route.params.salaryType;
    this.startSalary = this.$route.params.startSalary;
    this.endSalary = this.$route.params.endSalary;
    this.labelListHandle = this.$route.params.labelListHandle;
    this.employmentForm1 = this.$route.params.employmentForm1;
    this.employmentForm2 = this.$route.params.employmentForm2;
    this.employmentForm3 = this.$route.params.employmentForm3;
    this.employmentForm4 = this.$route.params.employmentForm4;
    this.welfareTreatment = this.$route.params.welfareTreatment;
    this.employmentConditions = this.$route.params.employmentConditions;
    this.other = this.$route.params.other;

    this.inputData1 = this.$route.params.inputData1;
    this.inputData2 = this.$route.params.inputData2;
    this.pathsList=this.$route.params.pathsList
    this.urlList=this.$route.params.urlList
    this.getSalaryType();
  },
  computed: {},
  mounted() {
    window.addEventListener('setItemEvent', this.languageChange, true)
  },
  destroyed() {
    window.removeEventListener('setItemEvent', this.languageChange, true)
  },
  methods: {
    // input校验
    inputData(num) {
      var vc1 = /^\d{1,20}$/;
      var vc2 = /^.{0,254}$/;


      if (num === 1) {
        if (!vc1.test(this.startSalary)) {
          this.$message({
            message:this.$t('warningJobSalary'),
            type:'warning'
          });
        }
      } else if (num === 2) {
        if (!vc1.test(this.endSalary)) {
          this.$message({
            message:this.$t('warningJobSalary'),
            type:'warning'
          });
        }
      } else if (num === 3) {
        if (!vc2.test(this.welfareTreatment)) {
          this.$message({
            message:this.$t('warningJobWelfareTreatment'),
            type:'warning'
          });
        }
          if(this.welfareTreatment===''){
           this.$message({
            message: this.$t("dataMiss"),
            type: "warning"
          });
          }
      } else if (num === 4) {
        if (!vc2.test(this.employmentConditions)) {
          this.$message({
            message:this.$t('warningJobEmploymentConditions'),
            type:'warning'
          });
        }
         if(this.employmentConditions===''){
           this.$message({
            message: this.$t("dataMiss"),
            type: "warning"
          });
         }
      } else if (num === 5) {
        if (!vc2.test(this.other)) {
          this.$message({
            message:this.$t('warningJobOther'),
            type:'warning'
          });
        }
         if(this.other===''){
           this.$message({
            message: this.$t("dataMiss"),
            type: "warning"
          });
          }
      }
    },

    //监听语言
    languageChange(e) {
      const that = this;
      console.log("------监听数据------")
      console.log(e)
      if (e.key && e.key == "language" && e.newValue) {
        that.language = e.newValue
        this.getLanguage();
        this.getSalaryType();
      }
    },
    getLanguage(){
      if(this.language === "CN"){
        this.dataItem1 = "hourSalary"
      }
      else {
        this.dataItem1 = "jphourSalary"
      }
    },
    getSalaryType(){
      var that=this;
      axios.get('/api/modules-parent/common/getDateItem',
        {
          params: {
            dataItem: that.dataItem1
          },
          headers:{
            'content-type': 'application/x-www-form-urlencoded',
            "token":localStorage.getItem("token")
          }
        })
        .then(function (res) {
          if(res.data.code === "A0000"){
            const aesFecInfo = JSON.parse(AES.decrypt(res.data.data));
            that.hourSalaryData=aesFecInfo.data;
            console.log(that.hourSalaryData);
          }else{
            console.log(res.data);
            that.$message.error(res.data.message);
          }
        })
        .catch((res) => {
          console.log(res);
        });
    },
    handleCommand3(evt) {
      this.inputData2=evt.code;
      this.salaryType=evt.name;
      console.log(evt);
    },
    //   标签高亮显示
    labelIsShow(num) {
      if (num === 1) {
        this.employmentForm1 = 1;
        this.labelListLength(1);
      } else if (num === 2) {
        this.employmentForm2 = 1;
        this.labelListLength(2);
      } else if (num === 3) {
        this.employmentForm3 = 1;
        this.labelListLength(3);
      } else if (num === 4) {
        this.employmentForm4 = 1;
        this.labelListLength(4);
      }
    },
    //判断labelListHandle长度 并且去重方法
    labelListLength(num) {
      if (this.labelListHandle.length < 4) {
        if (num === 1) {
          if (this.labelListHandle.indexOf("正社員") === -1) {
            this.labelListAdd(1);
          } else {
            return;
          }
        } else if (num === 2) {
          if (this.labelListHandle.indexOf("アルバイト") === -1) {
            this.labelListAdd(2);
          } else {
            return;
          }
        } else if (num === 3) {
          if (this.labelListHandle.indexOf("特定技能") === -1) {
            this.labelListAdd(3);
          } else {
            return;
          }
        } else if (num === 4) {
          if (this.labelListHandle.indexOf("技能実習生") === -1) {
            this.labelListAdd(4);
          } else {
            return;
          }
        } else {
          return;
        }
      }
    },
    //labelListHandle  push 方法
    labelListAdd(num) {
      if (num === 1) {
        this.labelListHandle.push("正社員");
      } else if (num === 2) {
        this.labelListHandle.push("アルバイト");
      } else if (num === 3) {
        this.labelListHandle.push("特定技能");
      } else if (num === 4) {
        this.labelListHandle.push("技能実習生");
      } else {
        return;
      }
      console.log(this.labelListHandle);
    },
    //标签删除方法
    labelDel(num) {
      if (num === 1) {
        for (var i = 0; i < this.labelListHandle.length; i++) {
          if (this.labelListHandle[i] === "正社員") {
            this.labelListHandle.splice(i, 1);
            this.employmentForm1 = 0;
          }
        }
      } else if (num === 2) {
        for (var i = 0; i < this.labelListHandle.length; i++) {
          if (this.labelListHandle[i] === "アルバイト") {
            this.labelListHandle.splice(i, 1);
            this.employmentForm2 = 0;
          }
        }
      } else if (num === 3) {
        for (var i = 0; i < this.labelListHandle.length; i++) {
          if (this.labelListHandle[i] === "特定技能") {
            this.labelListHandle.splice(i, 1);
            this.employmentForm3 = 0;
          }
        }
      } else if (num === 4) {
        for (var i = 0; i < this.labelListHandle.length; i++) {
          if (this.labelListHandle[i] === "技能実習生") {
            this.labelListHandle.splice(i, 1);
            this.employmentForm4 = 0;
          }
        }
      }
      console.log(this.labelListHandle);
    },
    judgeData(){
      if(this.salaryType === "" || this.welfareTreatment === ""
        || this.employmentConditions === "" || this.other === "") {
        this.$message({
          message: this.$t("dataEmpty"),
          type: 'warning'
        });
        this.judgeContinue = true;
      }
      else {
        this.judgeContinue = false;
      }
    },
    nextClick() {
      console.log("下一步");
      this.judgeData();
      if(this.judgeContinue === false) {
        this.$router.push({
          path: '/medicalInstitutionJobCreation3',
          name: 'medicalInstitutionJobCreation3',
          params: {
            //1
            jobName: this.jobName,
            jobPhoto1: this.jobPhoto1,
            jobPhoto2: this.jobPhoto2,
            jobPhoto3: this.jobPhoto3,
            workType: this.workType,
            recruitNumber: this.recruitNumber,
            workSpace: this.workSpace,
            workTime: this.workTime,
            recruiter: this.recruiter,
            userId: this.userId,
            principalTime: this.principalTime,
            label1: this.label1,
            label2: this.label2,
            label3: this.label3,
            label4: this.label4,
            workContent: this.workContent,
            //2
            salaryType: this.salaryType,
            startSalary: this.startSalary,
            endSalary: this.endSalary,
            labelListHandle: this.labelListHandle,
            employmentForm1: this.employmentForm1,
            employmentForm2: this.employmentForm2,
            employmentForm3: this.employmentForm3,
            employmentForm4: this.employmentForm4,
            welfareTreatment: this.welfareTreatment,
            employmentConditions: this.employmentConditions,
            other: this.other,
            inputData1: this.inputData1,
            inputData2: this.inputData2,
            pathsList: this.pathsList,
            urlList: this.urlList,
          }
        });
      }
    },
    returnClick(){
      // this.$router.push("/medicalInstitutionJobCreationOne");
        this.$router.push({
          path: "/medicalInstitutionJobCreationOne",
          name: "medicalInstitutionJobCreation",
          params: {
            jobName: this.jobName,
            jobPhoto1: this.jobPhoto1,
            jobPhoto2: this.jobPhoto2,
            jobPhoto3: this.jobPhoto3,
            workType: this.workType,
            recruitNumber: this.recruitNumber,
            workSpace: this.workSpace,
            workTime: this.workTime,
            recruiter: this.recruiter,
            userId: this.userId,
            principalTime: this.principalTime,
            label1: this.label1,
            label2: this.label2,
            label3: this.label3,
            label4: this.label4,
            workContent: this.workContent,
            inputData1: this.inputData1,
            pathsList: this.pathsList,
            urlList: this.urlList
          }
        });
    },
    saveClick(){
      this.judgeData();
      if(this.judgeContinue === false) {
        var fakeInfo = {
          employmentConditions: this.employmentConditions,//录用条件---2
          employmentForm1: this.employmentForm1,//雇佣形式1--------2
          employmentForm2: this.employmentForm2,//雇佣形式2--------2
          employmentForm3: this.employmentForm3,//雇佣形式3--------2
          employmentForm4: this.employmentForm4,//雇佣形式4--------2
          endSalary: this.endSalary,//结束薪资--------2
          hourSalary: this.inputData2,//期望薪资
          jobName: this.jobName,//事件名-----------1
          userId: this.userId,
          jobPhoto1: this.jobPhoto1,//事件照片1------1
          jobPhoto2: this.jobPhoto2,//事件照片2-------1
          jobPhoto3: this.jobPhoto3,//事件照片3--------1
          label1: this.label1,//标签1--------1
          label2: this.label2,//标签2--------1
          label3: this.label3,//标签3--------1
          label4: this.label4,//标签4--------1
          other: this.other,//其他--------------------2
          principalTime: this.principalTime,//目标录用时间------1
          recruitNumber: this.recruitNumber,//录用人数----------1
          startSalary: this.startSalary,//起薪--------------2
          welfareTreatment: this.welfareTreatment,//福利待遇------2
          workContent: this.workContent,//工作内容-----1
          workSpace: this.workSpace,//工作地--------1
          workTime: this.workTime,//工作时间-------1
          workType: this.inputData1//工作种类--------1
        }
        saveJobInfo(fakeInfo).then((res) => {
          console.log("求人信息添加保存2接口");
          console.log(res);
          if(res.data.code === "A0000"){
            this.$message({
              message: this.$t("saveSuccess"),
              type: 'success'
            });
            this.$router.push("/userInformationListOfMedicalInstitutionsSeekingApplicants");
          }
          else{
            this.$message.error(this.$t("saveFail"));
          }
        }).catch((res) => {
        })
      }
    },
  },
};
</script>
<style scoped>
.main-css {
  width: 100%;
  height: 100%;
  background: #fff;
}
.main-box {
  width: 700px;
  height: 100%;
  margin: 0 auto;
  margin-bottom: 80px;
}
.top-title {
  height: 40px;
  line-height: 40px;
  text-align: center;
  font-weight: 500;
  font-size: 18px;
  color: #686868;
  margin-top: 20px;
}
.progress-bar {
  height: 40px;
  width: 100%;
  margin-top: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 40px;
}
.line-between-active {
  height: 2px;
  width: 80px;
  background: #51abff;
}
.line-between-normal {
  height: 2px;
  width: 80px;
  background: #dce3e9;
}
.progress-item-active {
  width: 20px;
  height: 20px;
  line-height: 20px;
  background: #51abff;
  border-radius: 50%;
  text-align: center;
  font-weight: 400;
  font-size: 13px;
  color: #ffffff;
  position: relative;
}
.progress-title {
  position: absolute;
  left: 50%;
  bottom: -30px;
  margin-left: -75px;
  display: block;
  height: 24px;
  width: 150px;
  font-weight: 400;
  font-size: 14px;
  line-height: 24px;
  text-align: center;
  color: #252a31;
}
.line-center-active {
  width: 160px;
  height: 2px;
  background: #51abff;
}
.line-center-normal {
  width: 160px;
  height: 2px;
  background: #dce3e9;
}
.progress-item-normal {
  width: 20px;
  height: 20px;
  line-height: 20px;
  background: #dce3e9;
  border-radius: 50%;
  text-align: center;
  font-weight: 400;
  font-size: 13px;
  color: #252a31;
  position: relative;
}
.one-line-box {
  height: 45px;
  width: 100%;
  background: #fff;
  margin-top: 15px;
  display: flex;
  align-items: center;
  padding-left: 55px;
  box-sizing: border-box;
}
.small-box {
  width: 107px;
  height: 44px;
  border: 2px solid #b2b2b2;
  box-sizing: border-box;
  border-radius: 8px;
  position: relative;
  margin-right: 20px;
}
.box-title {
  padding: 0 5px;
  height: 20px;
  line-height: 20px;
  background: #ffffff;
  position: absolute;
  top: -10px;
  left: 10px;
  font-weight: 400;
  font-size: 14px;
  line-height: 24px;
  color: #51abff;
  z-index: 10;
}
.box-title span {
  font-weight: 600;
  font-size: 12px;
  margin-left: 2px;
  color: #fc630c;
}
.small-box /deep/ .el-dropdown-link {
  width: 90px;
  height: 40px;
  line-height: 40px;
  display: inline-block;
}
.small-box /deep/ .el-dropdown {
  height: 40px;
  margin-left: 10px;
  line-height: 40px;
}
.small-box /deep/ .el-icon-arrow-down {
  float: right;
  line-height: 40px;
  margin-right: 5px;
}
.big-box {
  width: 162px;
  height: 44px;
  border: 2px solid #b2b2b2;
  box-sizing: border-box;
  border-radius: 8px;
  position: relative;
  margin-right: 10px;
}
.big-box /deep/ .el-input__inner {
  width: 150px;
  height: 40px;
  border: 2px solid transparent;
  box-sizing: border-box;
  margin-left: 4px;
  font-weight: 400;
  font-size: 14px;
  letter-spacing: 0.25px;
  color: #09101d;
}
.tilde {
  font-weight: 400;
  font-size: 14px;
  color: #000000;
  margin-right: 10px;
}

.label-line-box {
  width: 640px;
  height: 50px;
  margin: 0 auto;
  margin: 15px 0 0 55px;
  position: relative;
}
.label-box {
  float: left;
  height: 24px;
  padding: 0 5px;
  line-height: 24px;
  background: #b2b2b2;
  border-radius: 4px;
  font-weight: 400;
  font-size: 14px;
  color: #ffffff;
  cursor: pointer;
  overflow: hidden;
  margin-right: 20px;
  margin-top: 25px;
}
.label-box-active {
  float: left;
  height: 24px;
  padding: 0 5px;
  line-height: 24px;
  background: #51abff;
  border-radius: 4px;
  font-weight: 400;
  font-size: 14px;
  color: #ffffff;
  cursor: pointer;
  overflow: hidden;
  margin-right: 20px;
  margin-top: 25px;
}
.label-box-active span {
  height: 13px;
  width: 13px;
  background: #fff;
  border-radius: 50%;
  line-height: 13px;
  text-align: center;
  margin-left: 10px;
  display: inline-block;
  color: #b2b2b2;
}
.label-box span {
  height: 13px;
  width: 13px;
  background: #fff;
  border-radius: 50%;
  line-height: 13px;
  text-align: center;
  margin-left: 10px;
  display: inline-block;
  color: #b2b2b2;
}
.big-line-box {
  height: 127px;
  width: 640px;
  margin: 0 auto;
  margin: 25px 0 0 55px;
}
.big-box-css {
  height: 127px;
  width: 640px;
  background: #ffffff;
  border: 2px solid #b2b2b2;
  box-sizing: border-box;
  border-radius: 8px;
  position: relative;
}
.big-box-css /deep/ .el-textarea__inner {
  border: 1px solid transparent;
  height: 107px;
  width: 630px;
  margin-left: 2px;
  margin-top: 10px;
}
.other-line-box {
  height: 107px;
  width: 640px;
  margin: 0 auto;
  margin: 25px 0 0 55px;
}
.other-box-css {
  height: 127px;
  width: 640px;
  background: #ffffff;
  border: 2px solid #b2b2b2;
  box-sizing: border-box;
  border-radius: 8px;
  position: relative;
}
.other-box-css /deep/ .el-textarea__inner {
  border: 1px solid transparent;
  height: 106px;
  width: 630px;
  margin-left: 2px;
  margin-top: 10px;
}

.line-button-box {
  height: 40px;
  width: 100%;
  display: flex;
  justify-content: center;
  margin-top: 30px;
  padding: 0 0 0 55px;
  box-sizing: border-box;
}
.button-css1 {
  width: 85px;
  height: 40px;
  background: #fafafa;
  border: 1px solid #51abff;
  box-sizing: border-box;
  border-radius: 4px;
  font-weight: 500;
  font-size: 12px;
  color: #51abff;
  margin-right: 25px;
  cursor: pointer;
}
.button-css2 {
  width: 150px;
  height: 40px;
  background: #fc630c;
  border-radius: 4px;
  box-sizing: border-box;
  border-radius: 4px;
  font-weight: 500;
  font-size: 12px;
  color: #fff;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/pages/medicalInstitutionJobCreation2/index.vue